import Vue from 'vue';
import { TweenLite } from 'gsap/all';
import WrongIcon from '../icons/RedXSolidIcon.vue';
import CorrectIcon from '../icons/SuccessCheckSolidIcon.vue';
export default Vue.extend({
    props: {
        options: {
            type: Array,
            required: true
        },
        sentenceIndex: {
            type: Number,
            required: true
        },
        dropdownIndex: {
            type: Number,
            required: true
        },
        onItemSelect: {
            type: Function,
            required: true
        },
        enabled: {
            type: Boolean,
            default: true
        },
        isCorrect: {
            type: Boolean,
            default: false
        },
        numOfAttempts: {
            type: Number,
            default: 0
        }
    },
    components: {
        WrongIcon,
        CorrectIcon
    },
    data() {
        return {
            collapsed: true,
            focusedOption: null,
            selection: null,
            showIcon: false
        };
    },
    mounted() {
        var _a;
        this.$refs.dropdownHeader.style.width = `${(((_a = this.$refs.dropdownOptionSpacer) === null || _a === void 0 ? void 0 : _a.clientWidth) + 72).toString()}px`;
    },
    watch: {
        numOfAttempts() {
            this.showIcon = true;
            TweenLite.delayedCall(1.5, () => {
                if (this.selection && !this.selection.correct) {
                    this.selection = null;
                }
                this.showIcon = false;
            });
        }
    },
    methods: {
        handleBlur(e) {
            setTimeout(() => {
                if (e.target.getAttribute('data-index') ===
                    this.focusedOption.getAttribute('data-index')) {
                    this.collapsed = true;
                }
            }, 250);
        },
        onDropDownClick() {
            if (!this.collapsed || this.isCorrect)
                return;
            this.collapsed = !this.collapsed;
            setTimeout(() => {
                var _a;
                const optionNodes = document.getElementsByClassName(`pick-the-answer-dropdown-option`);
                ((_a = optionNodes === null || optionNodes === void 0 ? void 0 : optionNodes.item) === null || _a === void 0 ? void 0 : _a.call(optionNodes, 0)).focus();
            }, 250);
        },
        handleSelection(option) {
            this.onItemSelect({
                sentenceIndex: this.sentenceIndex,
                dropdownIndex: this.dropdownIndex,
                option
            });
            this.selection = option;
            this.collapsed = true;
        },
        shiftOptionFocus(index) {
            var _a;
            const optionNodes = document.getElementsByClassName(`pick-the-answer-dropdown-option`);
            ((_a = optionNodes === null || optionNodes === void 0 ? void 0 : optionNodes.item) === null || _a === void 0 ? void 0 : _a.call(optionNodes, index)).focus();
        }
    }
});
